import React from "react";
import { Link } from "react-router-dom";
import data from "../../../_data/about.json";
import { isActive } from "../lib/nav.js";

export default function About() {
  const hero = data?.hero;
  const navItems = data?.nav;

  if (!data) {
    return (
      <section className="about">
        <div className="about-empty">About data not found.</div>
      </section>
    );
  }

  return (
    <section className="about" aria-label="About Us">
      {/* Hero Section */}
      {hero && (
        <div className="hero-banner">
          <div className="hero-col">
            <div className="hero-headline">
              <h1 className="hero-title">{hero.title}</h1>
              <p className="hero-description">{hero.description}</p>
            </div>
            <div className="hero-buttons">
              <a href="/about/contact-us/" className="hero-btn hero-btn-filled">
                <span className="hero-btn-text">Start a JumpStart</span>
              </a>
            </div>
          </div>
          <div className="hero-patterns" aria-hidden="true">
            <img src="/assets/img/banner.png" alt="" className="hero-pattern-image" />
          </div>
        </div>
      )}

      {/* Navigation to subpages */}
      {navItems && navItems.length > 0 && (
        <div className="sectionContentContainer">
          <div className="sectionContentNav">
            {navItems.map((item) => (
              <li
                key={item.href}
                href={item.href}
                className={`sectionContentItem ${isActive(item.href) ? "item-selected" : ""}`}
              >
                <Link to={item.href}>{item.name}</Link>
              </li>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
